

import { ELEMENT_PARAGRAPH } from "@udecode/plate";
import { usePlateEditorState, type PlateEditor } from "@udecode/plate-core";
import { EditorState } from "@/common/editor/RuleAuthor/multiEditor";
import { getSelectedNode, not } from "../../plugins/util";
import { isWithinOperator } from "../operator/operatorTransforms";
import { TableToolbarButton } from "./TableToolbarButton";
import { canDeleteRow, deleteRow, deleteTable, insertRow, insertTable, isInTable } from "./transforms";
import Icon from "@imminently/decisively-ui/Icon";
import Tooltip from "@imminently/decisively-ui/Tooltip";

const selectedNodeIsParagraph = (editor: PlateEditor) => {
  const [node] = getSelectedNode(editor);
  return node && node.type === ELEMENT_PARAGRAPH;
};

export const TablesToolbar = () => {
  const editor = usePlateEditorState(EditorState.rules);
  const deleteRowDisabled = !canDeleteRow(editor);

  return (
    <>
      <TableToolbarButton
        icon={<Icon name="add-table" />}
        tooltip="Insert Decision Table"
        // can only insert if in paragraph, not already in a table
        disable={(e) => !(selectedNodeIsParagraph(e) && !isInTable(e) && !isWithinOperator(e))}
        transform={insertTable}
      />
      <TableToolbarButton
        hideDisabled
        icon={<Icon name="add-row-below" />}
        tooltip="Insert row"
        hotkeys={["shift", "enter"]}
        transform={insertRow}
        disable={not(isInTable)}
      />
      <Tooltip>
        <Tooltip.Trigger asChild>
          <span className="inline-flex">
            <TableToolbarButton
              icon={<Icon name="delete-row" />}
              transform={deleteRow}
              hide={(editor) => !isInTable(editor)}
              disable={(editor) => !canDeleteRow(editor)}
            />
          </span>
        </Tooltip.Trigger>
        <Tooltip.Content>
          {deleteRowDisabled ? "Delete Row: Tables must keep at least one condition row." : "Delete row"}
        </Tooltip.Content>
      </Tooltip>
      <TableToolbarButton
        hideDisabled
        icon={<Icon name="delete" />}
        tooltip="Delete table"
        transform={deleteTable}
        disable={not(isInTable)}
      />
    </>
  );
};
